import { DifficultyLevelType } from 'constants/difficulty';
import { DealData, emptyWinScore, SCORE_NA, Store } from 'game/store/gameStore';
import { getRandomItem } from './helpers/array';

export async function getSuit(id: string) {
    const dealGroup = await getDifficultyDeals(Store.difficulty);

    try {
        if (dealGroup[id]) {
            const modules = import.meta.glob('./deals/*.js');
            const fetchDeal = async () => {
                const path = `./deals/${dealGroup[id]}.js`;
                const loader = modules[path];
                if (!loader) throw new Error('Module not found');
                const module = await loader();
                return module;
            };
            const module = await fetchDeal();
            const dealData = module.default as DealData;
            return { difficulty: Store.difficulty, cards: mapCards(dealData[id]) };
        } else {
            throw new Error(`Deal ID not found for id: ${id} in group: ${Store.difficulty}, Reloaded page`);
        }
    } catch (error) {
        // localStorage.clear();
        // window.location.reload();
    }

    // return null;
}
export async function getSuitWinScore() {
    const dealGroup = await getDifficultyScore(Store.difficulty);
    let score = { ...emptyWinScore };
    if (dealGroup[Store.gameId]) {
        const parts = dealGroup[Store.gameId].split(',');
        if (parts.length === 6) {
            for (let i = 0; i < Object.keys(score).length; i++) {
                const key = Object.keys(score)[i] as keyof typeof score;
                score[key] = parts.length > 1 ? parseInt(parts[i]) : SCORE_NA;
            }
            Store.setGameWinScore(score);
            return;
        }
    }

    Store.setGameWinScore(null);

    // return null;
}
export async function getDifficultyDeals(key: DifficultyLevelType) {
    const fileList = {
        [DifficultyLevelType.KLONDIKE_RANDOM_3CARDS]: 'deal3c_random',
        [DifficultyLevelType.KLONDIKE_MEDIUM_3CARDS]: 'deal3c_medium',
        [DifficultyLevelType.KLONDIKE_HARD_3CARDS]: 'deal3c_hard',
        [DifficultyLevelType.KLONDIKE_EXPERT_3CARDS]: 'deal3c_expert',
        [DifficultyLevelType.KLONDIKE_MASTER_3CARDS]: 'deal3c_master',

        [DifficultyLevelType.KLONDIKE_EASY_1CARD]: 'deal1c_easy',
        [DifficultyLevelType.KLONDIKE_MEDIUM_1CARD]: 'deal1c_medium',
        [DifficultyLevelType.KLONDIKE_HARD_1CARD]: 'deal1c_hard',
        [DifficultyLevelType.KLONDIKE_EXPERT_1CARD]: 'deal1c_expert',
        [DifficultyLevelType.KLONDIKE_MASTER_1CARD]: 'deal1c_master',
        [DifficultyLevelType.KLONDIKE_RANDOM_1CARD]: 'deal1c_random',

        [DifficultyLevelType.SPIDER_EASY_1SUIT]: 'spider1s_easy',
        [DifficultyLevelType.SPIDER_MEDIUM_1SUIT]: 'spider1s_medium',
        [DifficultyLevelType.SPIDER_HARD_1SUIT]: 'spider1s_hard',
        [DifficultyLevelType.SPIDER_EXPERT_1SUIT]: 'spider1s_expert',
        [DifficultyLevelType.SPIDER_MASTER_1SUIT]: 'spider1s_master',
        [DifficultyLevelType.SPIDER_EXPERT_2SUIT]: 'spider2s_expert',
        [DifficultyLevelType.SPIDER_MASTER_2SUIT]: 'spider2s_master',
        [DifficultyLevelType.SPIDER_HARD_2SUIT]: 'spider2s_hard',
        [DifficultyLevelType.SPIDER_EXPERT_4SUIT]: 'spider4s_expert',
        [DifficultyLevelType.SPIDER_MASTER_4SUIT]: 'spider4s_master',

        [DifficultyLevelType.FREECELL_EASY]: 'free_easy',
        [DifficultyLevelType.FREECELL_MEDIUM]: 'free_medium',
        [DifficultyLevelType.FREECELL_HARD]: 'free_hard',
        [DifficultyLevelType.FREECELL_EXPERT]: 'free_expert',
        [DifficultyLevelType.FREECELL_MASTER]: 'free_master',
    };
    try {
        if (!fileList[key]) {
            throw new Error(`getDifficultyDeals: Deal not found for key: ${key}, Reloaded page`);
        }
        const fetchDealList = () => import(`./deals/${fileList[key]}.js`);
        const module = await fetchDealList();
        return module.default;
    } catch (error) {
        localStorage.clear();
        window.location.reload();
    }
}
export async function getDifficultyScore(key: DifficultyLevelType) {
    const fileList = {
        [DifficultyLevelType.KLONDIKE_RANDOM_3CARDS]: 'deal3c_random',
        [DifficultyLevelType.KLONDIKE_MEDIUM_3CARDS]: 'deal3c_medium',
        [DifficultyLevelType.KLONDIKE_HARD_3CARDS]: 'deal3c_hard',
        [DifficultyLevelType.KLONDIKE_EXPERT_3CARDS]: 'deal3c_expert',
        [DifficultyLevelType.KLONDIKE_MASTER_3CARDS]: 'deal3c_master',

        [DifficultyLevelType.KLONDIKE_EASY_1CARD]: 'deal1c_easy',
        [DifficultyLevelType.KLONDIKE_MEDIUM_1CARD]: 'deal1c_medium',
        [DifficultyLevelType.KLONDIKE_HARD_1CARD]: 'deal1c_hard',
        [DifficultyLevelType.KLONDIKE_EXPERT_1CARD]: 'deal1c_expert',
        [DifficultyLevelType.KLONDIKE_MASTER_1CARD]: 'deal1c_master',
        [DifficultyLevelType.KLONDIKE_RANDOM_1CARD]: 'deal1c_random',

        [DifficultyLevelType.SPIDER_EASY_1SUIT]: 'spider1s_easy',
        [DifficultyLevelType.SPIDER_MEDIUM_1SUIT]: 'spider1s_medium',
        [DifficultyLevelType.SPIDER_HARD_1SUIT]: 'spider1s_hard',
        [DifficultyLevelType.SPIDER_EXPERT_1SUIT]: 'spider1s_expert',
        [DifficultyLevelType.SPIDER_MASTER_1SUIT]: 'spider1s_master',
        [DifficultyLevelType.SPIDER_EXPERT_2SUIT]: 'spider2s_expert',
        [DifficultyLevelType.SPIDER_MASTER_2SUIT]: 'spider2s_master',
        [DifficultyLevelType.SPIDER_HARD_2SUIT]: 'spider2s_hard',
        [DifficultyLevelType.SPIDER_EXPERT_4SUIT]: 'spider4s_expert',
        [DifficultyLevelType.SPIDER_MASTER_4SUIT]: 'spider4s_master',

        [DifficultyLevelType.FREECELL_EASY]: 'free_easy',
        [DifficultyLevelType.FREECELL_MEDIUM]: 'free_medium',
        [DifficultyLevelType.FREECELL_HARD]: 'free_hard',
        [DifficultyLevelType.FREECELL_EXPERT]: 'free_expert',
        [DifficultyLevelType.FREECELL_MASTER]: 'free_master',
    };
    try {
        if (!fileList[key]) {
            throw new Error(`getDifficultyScore: Deal not found for key: ${key}, Reloaded page`);
        }
        const fetchDealScore = () => import(`./deals/${fileList[key]}_score.js`);
        const module = await fetchDealScore();
        return module.default;
    } catch (error) {
        localStorage.clear();
        window.location.reload();
    }
}
export async function getRandomDifficultyId(type: DifficultyLevelType) {
    const randomDeal = async (type: DifficultyLevelType) => {
        const deals = await getDifficultyDeals(type);
        const id = getRandomItem(Object.keys(deals));
        return id;
    };
    return await randomDeal(type);
}

const cardRank = ['empty index 0', 'A', '2', '3', '4', '5', '6', '7', '8', '9', 'T', 'J', 'Q', 'K'];

function mapCards(suitString: string) {
    const cards = [] as string[];
    const suitArray = suitString.split('*');
    suitArray.forEach((setString) => {
        const sets = setString.split(':');
        // do not use sets[0] - something for mobile app
        const value = cardRank[parseInt(sets[1])];
        const color = sets[2];
        // const open = sets[3];
        cards.push(value + color);
    });

    return cards;
}
